import React from 'react';

import { AppRoutes } from './app.routes';

export function Routes() {
  return <AppRoutes />;
}
